(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zarabia-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-root]').forEach((root)=>{
    const productData = JSON.parse(document.querySelector('[data-product-json]')?.textContent || '{"variants":[]}');
    const radios=[...root.querySelectorAll('[data-option-position]')];
    const input=root.querySelector('[data-product-variant-input]');
    const currentPrice=root.querySelector('[data-current-price]');
    const comparePrice=root.querySelector('[data-compare-price]');
    const submitPrice=root.querySelector('[data-submit-price]');
    const submit=root.querySelector('[data-product-submit]');
    const submitLabel=root.querySelector('[data-submit-label]');
    const submitSeparator=root.querySelector('[data-submit-separator]');
    const stock=root.querySelector('[data-product-stock]');
    const stockText=root.querySelector('[data-product-stock-text]');
    const selectedColour=root.querySelector('[data-selected-colour]');
    const form=root.querySelector('.zp-form');
    const quantity=root.querySelector('[data-product-quantity]');
    const quantityMinus=root.querySelector('[data-quantity-minus]');
    const quantityPlus=root.querySelector('[data-quantity-plus]');
    const expressWrap=root.querySelector('[data-express-wrap]');
    const expressVariantInput=root.querySelector('[data-express-variant-input]');
    const expressQuantity=root.querySelector('[data-express-quantity]');
    const mobileBuy=root.querySelector('[data-mobile-buy]');
    const mobileBuyPrice=root.querySelector('[data-mobile-buy-price]');
    const mixColours=root.querySelector('[data-mix-colours]');
    const mixColourList=root.querySelector('[data-mix-colour-list]');
    const formError=root.querySelector('[data-product-error]');
    const isPouf=root.dataset.isPouf==='true';
    const gallery=root.querySelector('[data-product-gallery]');
    const galleryPosition=root.querySelector('[data-gallery-position]');
    const analyticsPayload=()=>{
      const variant=productData.variants.find(item=>String(item.id)===String(input?.value));
      return {product_id:productData.productId,product_title:productData.productTitle,variant_id:variant?.id||null,variant_title:variant?.options?.join(' / ')||'',quantity:Math.max(1,Math.floor(Number(quantity?.value)||1)),value:variant?variant.priceCents/100:0,currency:productData.currency};
    };
    const publishFunnelEvent=(name,extra={})=>{
      const detail={...analyticsPayload(),...extra};
      try{if(window.Shopify?.analytics?.publish)window.Shopify.analytics.publish(`zarabia:${name}`,detail)}catch(error){}
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push({event:`zarabia_${name}`,...detail});
    };
    const visibleSlides=()=>[...gallery?.querySelectorAll('[data-gallery-slide].is-visible')||[]].sort((a,b)=>Number(getComputedStyle(a).order)-Number(getComputedStyle(b).order));
    const galleryStep=()=>{const first=visibleSlides()[0];return first?first.getBoundingClientRect().width+12:0};
    const updateGalleryPosition=()=>{if(!galleryPosition)return;const slides=visibleSlides();galleryPosition.textContent=slides.length?`${Math.min(slides.length,Math.round(gallery.scrollLeft/galleryStep())+1)} / ${slides.length}`:''};
    root.querySelector('[data-gallery-next]')?.addEventListener('click',()=>gallery.scrollBy({left:galleryStep(),behavior:'smooth'}));
    root.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>gallery.scrollBy({left:-galleryStep(),behavior:'smooth'}));
    gallery?.addEventListener('scroll',updateGalleryPosition,{passive:true});
    const selectedOptions=()=>{const out=[];radios.filter(r=>r.checked).forEach(r=>out[Number(r.dataset.optionPosition)-1]=r.value);return out};
    let lastTrackedColour=selectedOptions()[0]||'';
    const formatCurrency=cents=>new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:productData.currency}).format(cents/100);
    const renderMixColours=()=>{
      if(!isPouf||!mixColours||!mixColourList)return;
      const count=Math.max(1,Math.floor(Number(quantity?.value)||1));
      if(count<2){mixColours.hidden=true;mixColourList.replaceChildren();return}
      const previous=[...mixColourList.querySelectorAll('select')].map(select=>select.value);
      mixColours.hidden=false;
      mixColourList.replaceChildren();
      for(let index=0;index<count;index+=1){
        const row=document.createElement('div');row.className='zp-mix-colours__row';
        const label=document.createElement('label');const preview=document.createElement('img');const select=document.createElement('select');
        select.id=`zp-mix-colour-${index+1}`;select.dataset.mixVariant='';label.htmlFor=select.id;label.textContent=`Pouf ${index+1}`;
        preview.className='zp-mix-colours__preview';preview.width=108;preview.height=108;preview.loading='lazy';
        productData.variants.filter(variant=>variant.available).forEach(variant=>{const option=document.createElement('option');option.value=variant.id;option.textContent=variant.options.join(' / ');select.appendChild(option)});
        select.value=previous[index]||input.value;
        const updatePreview=()=>{const selectedVariant=productData.variants.find(variant=>String(variant.id)===String(select.value));preview.src=selectedVariant?.image||'';preview.alt=selectedVariant?`${productData.productTitle} in ${selectedVariant.options.join(' / ')}`:'';preview.hidden=!selectedVariant?.image};
        select.addEventListener('change',()=>{updatePreview();updateTotals();publishFunnelEvent('multi_pouf_colour_selected',{pouf_position:index+1,selected_variant_id:Number(select.value)})});
        updatePreview();row.append(label,preview,select);mixColourList.appendChild(row);
      }
    };
    const updateTotals=()=>{
      const variant=productData.variants.find(v=>String(v.id)===String(input.value));
      if(!variant)return;
      const count=Math.max(1,Math.floor(Number(quantity?.value)||1));
      if(isPouf&&count>1&&mixColourList?.children.length!==count)renderMixColours();
      const mixedVariants=isPouf&&count>1?[...mixColourList.querySelectorAll('select')].map(select=>productData.variants.find(item=>String(item.id)===select.value)).filter(Boolean):[];
      const totalCents=mixedVariants.length===count?mixedVariants.reduce((sum,item)=>sum+item.priceCents,0):variant.priceCents*count;
      const allAvailable=mixedVariants.length===count?mixedVariants.every(item=>item.available):variant.available;
      const totalFormatted=formatCurrency(totalCents);
      submit.disabled=!allAvailable;
      if(mobileBuy)mobileBuy.disabled=!allAvailable;
      submitPrice.textContent=allAvailable?totalFormatted:'';
      if(mobileBuyPrice)mobileBuyPrice.textContent=totalFormatted;
      if(expressQuantity)expressQuantity.value=count;
      if(expressWrap)expressWrap.hidden=isPouf&&count>1;
    };
    const refresh=()=>{
      const opts=selectedOptions();
      const variant=productData.variants.find(v=>v.options.every((value,index)=>value===opts[index]));
      if(!variant)return;
      input.value=variant.id;
      if(expressVariantInput){expressVariantInput.value=variant.id;expressVariantInput.dispatchEvent(new Event('change',{bubbles:true}))}
      const formatted=variant.formattedPrice;
      currentPrice.textContent=formatted;
      comparePrice.textContent=variant.formattedCompareAt||'';
      comparePrice.hidden=!variant.formattedCompareAt;
      submit.disabled=!variant.available;
      if(mobileBuy)mobileBuy.disabled=!variant.available;
      submitLabel.textContent=variant.available?productData.addToBag:productData.unavailable;
      submitSeparator.textContent=variant.available?'—':'';
      submitPrice.textContent=variant.available?formatted:'';
      stock.classList.toggle('is-unavailable',!variant.available);
      stockText.textContent=variant.available?productData.stockText:productData.unavailable;
      if(selectedColour)selectedColour.textContent=opts[0];
      if(opts[0]!==lastTrackedColour){publishFunnelEvent('colour_selected',{selected_colour:opts[0]});lastTrackedColour=opts[0]}
      const variantUrl=new URL(window.location.href);variantUrl.searchParams.set('variant',variant.id);history.replaceState({},'',variantUrl.pathname+variantUrl.search+variantUrl.hash);
      if(isPouf){
        const colour=opts[0].toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
        root.querySelector('[data-product-overview]')?.classList.add('is-visible');
        root.querySelectorAll('[data-product-media]').forEach(media=>media.classList.toggle('is-visible',media.dataset.colour===colour||media.dataset.colour==='shared'||media.classList.contains('zp-media--video')));
        root.querySelector('[data-product-gallery]')?.scrollTo({left:0,behavior:'smooth'});
        requestAnimationFrame(updateGalleryPosition);
      }else{
        const colour=opts[0].toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
        root.querySelectorAll('[data-product-media]').forEach(media=>media.classList.toggle('is-visible',media.dataset.colour===colour||media.dataset.colour==='shared'));
        root.querySelector('[data-product-gallery]')?.scrollTo({left:0,behavior:'smooth'});
        requestAnimationFrame(updateGalleryPosition);
      }
      updateTotals();
    };
    radios.forEach(r=>{r.addEventListener('change',refresh);r.addEventListener('click',refresh)});
    const changeQuantity=delta=>{
      if(!quantity)return;
      const current=Math.max(1,Math.floor(Number(quantity.value)||1));
      quantity.value=Math.max(1,current+delta);
      quantity.dispatchEvent(new Event('change',{bubbles:true}));
    };
    quantityMinus?.addEventListener('click',()=>changeQuantity(-1));
    quantityPlus?.addEventListener('click',()=>changeQuantity(1));
    quantity?.addEventListener('change',()=>{renderMixColours();updateTotals()});
    quantity?.addEventListener('input',()=>{renderMixColours();updateTotals()});
    form?.addEventListener('submit',async event=>{
      const count=Math.max(1,Math.floor(Number(quantity?.value)||1));
      publishFunnelEvent('add_to_bag_clicked',{mixed_colours:isPouf&&count>1});
      if(!isPouf||count<2)return;
      event.preventDefault();
      const ids=[...mixColourList.querySelectorAll('select')].map(select=>Number(select.value));
      if(ids.length!==count)return;
      const grouped=ids.reduce((items,id)=>{items[id]=(items[id]||0)+1;return items},{});
      const items=Object.entries(grouped).map(([id,itemQuantity])=>({id:Number(id),quantity:itemQuantity}));
      if(formError)formError.hidden=true;
      submit.disabled=true;if(mobileBuy)mobileBuy.disabled=true;submitLabel.textContent=productData.addingLabel;submitSeparator.textContent='';submitPrice.textContent='';
      try{
        const response=await fetch(productData.cartAddUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if(!response.ok)throw new Error('Cart request failed');
        const cartResult=await response.json();
        publishFunnelEvent('multi_pouf_added_to_cart',{item_count:count,variant_ids:ids});
        document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:cartResult,source:'zarabia-mixed-colours'}}));
        window.location.assign(productData.cartUrl);
      }catch(error){
        if(formError){formError.textContent=productData.cartError;formError.hidden=false}
        submit.disabled=false;if(mobileBuy)mobileBuy.disabled=false;submitLabel.textContent=productData.addToBag;submitSeparator.textContent='—';updateTotals();
      }
    });
    mobileBuy?.addEventListener('click',()=>submit?.click());
    expressWrap?.addEventListener('click',event=>{if(event.target.closest?.('button'))publishFunnelEvent('express_checkout_clicked')});
    publishFunnelEvent('product_viewed');
    if(isPouf){const reviews=document.querySelector('#zp-reviews');if(reviews)root.insertAdjacentElement('afterend',reviews)}
    renderMixColours();
    updateTotals();
    if(isPouf)refresh();
    updateGalleryPosition();
    const track=document.querySelector('[data-review-track]'),cards=track?[...track.children]:[],dots=document.querySelector('[data-review-dots]');
    if(track&&cards.length){
      cards.forEach((_,i)=>{const dot=document.createElement('i');if(i===0)dot.classList.add('is-active');dots.appendChild(dot)});
      const step=()=>cards[0].getBoundingClientRect().width+18;
      document.querySelector('[data-review-next]')?.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));
      document.querySelector('[data-review-prev]')?.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
      track.addEventListener('scroll',()=>{const index=Math.round(track.scrollLeft/step());[...dots.children].forEach((d,i)=>d.classList.toggle('is-active',i===index))},{passive:true});
    }
  });

  } catch(e) { console.error(e); }
})();
})();
